
<template>
  <span>
    <button type="button" class="btn btn-outline-grey btn-icon" @click="open">
      <i class="icon-upload4 "></i>
    </button>

    <modal-in-front v-bind:title="upload" ref="thisModal" size="modal-md">
      <div style="margin:auto;overflow:visible;position:relative">
        <p v-if="urlerrors.length">
          <ul>
            <li v-for="error in urlerrors" class="validation-invalid-label">{{ error }}</li>
          </ul>
        </p>
        <upload-file-selector2 ref="uploader" @change="urlChange"></upload-file-selector2>
      </div>
    </modal-in-front>
  </span>

</template>

<script>

  import ModalInFront from "../modals/modal-in-front.vue";
  import UploadSelector2 from "../upload/upload-file-selector2.vue";
  var urlerrors = [];

  export default {
    name: 'upload-button',
    components: {
      UploadSelector2,
      ModalInFront
    },
    props: [
    ],
    data() {
      return {
        filesettings: {},
        internalurl: '',
        url: '',
        text: '',
        urlerrors
      }
    },
    methods: {
      urlChange(val, text, settings) {
        this.filesettings = settings;
        this.url = val;
        this.text = text;
        this.$emit('change', this.url, this.text, this.filesettings);
      },
      open() {
        this.$refs.thisModal.open();
      }
    },
    created() {

    },
    mounted() {

    }
  }
</script>

<style scoped>
  .btn-outline-grey {
    color: #aaa;
    border-color: #aaa;
  }
  .btn-outline-grey:not(:disabled):not(.disabled).active, .btn-outline-grey:not(:disabled):not(.disabled):active, .show > .btn-outline-grey {
    color: #fff;
    background-color: #aaa;
    border-color: #aaa;
  }
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-button.vue